"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderNavigationMobile = void 0;
var react_1 = __importDefault(require("react"));
var HeaderNavigationMobile_module_scss_1 = __importDefault(require("./HeaderNavigationMobile.module.scss"));
var react_router_dom_1 = require("react-router-dom");
var Svg_1 = require("../svg/Svg");
var modalSlice_1 = require("../../redux/slice/modalSlice");
var selectors_1 = require("../../redux/selectors");
var react_redux_1 = require("react-redux");
var ThemeContext_1 = require("../../context/ThemeContext");
var icon_theme_webp_1 = __importDefault(require("../../assets/images/icon_theme.webp"));
var HeaderNavigationMobile = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var menuState = (0, react_redux_1.useSelector)(selectors_1.modalSelector).burgerMenu.modalState;
    var favoritesCount = (0, react_redux_1.useSelector)(selectors_1.favoritesSelector).favoritesCount;
    var _a = (0, ThemeContext_1.useTheme)(), theme = _a.theme, toggleTheme = _a.toggleTheme;
    var burgerHandle = function () {
        if (menuState) {
            dispatch((0, modalSlice_1.closeModal)('burgerMenu'));
        }
        else {
            dispatch((0, modalSlice_1.openModal)('burgerMenu'));
        }
    };
    return (react_1.default.createElement("article", { className: "".concat(HeaderNavigationMobile_module_scss_1.default.header_navigation_mobile, " ").concat(HeaderNavigationMobile_module_scss_1.default[theme]) },
        react_1.default.createElement("div", { className: HeaderNavigationMobile_module_scss_1.default.header_navigation_mobile__heart },
            react_1.default.createElement(react_router_dom_1.Link, { className: HeaderNavigationMobile_module_scss_1.default.header_navigation_mobile__heart_link, to: '/favorites' },
                react_1.default.createElement(Svg_1.Heart, { customClass: HeaderNavigationMobile_module_scss_1.default.heart }),
                react_1.default.createElement("div", { className: HeaderNavigationMobile_module_scss_1.default.header_navigation_mobile__count },
                    react_1.default.createElement("span", null, favoritesCount)))),
        react_1.default.createElement("div", { className: HeaderNavigationMobile_module_scss_1.default.header_navigation_mobile__phone },
            react_1.default.createElement(Svg_1.Phone, null)),
        react_1.default.createElement("button", { className: "".concat(HeaderNavigationMobile_module_scss_1.default.hamburger, " ").concat(menuState ? HeaderNavigationMobile_module_scss_1.default.hamburger_active : ''), type: "button", onClick: burgerHandle },
            react_1.default.createElement("span", { className: HeaderNavigationMobile_module_scss_1.default.hamburger__element }),
            react_1.default.createElement("span", { className: HeaderNavigationMobile_module_scss_1.default.hamburger__element }),
            react_1.default.createElement("span", { className: HeaderNavigationMobile_module_scss_1.default.hamburger__element })),
        react_1.default.createElement("div", null,
            react_1.default.createElement("img", { loading: "lazy", onClick: toggleTheme, id: "theme-icon", className: HeaderNavigationMobile_module_scss_1.default.theme_toggle, src: icon_theme_webp_1.default, alt: "Theme Icon", style: { width: '32px', height: '32px', marginTop: '0px', marginLeft: '16px' } }))));
};
exports.HeaderNavigationMobile = HeaderNavigationMobile;
